import { RRule, Frequency } from "rrule";
import { OptionPair } from "types/todolist";

export const FREQ_LIST: OptionPair[] = [
  { key: "daily", label: "Day(s)", value: RRule.DAILY },
  { key: "weekly", label: "Week(s)", value: RRule.WEEKLY },
  { key: "monthly", label: "Month(s)", value: RRule.MONTHLY },
];

export const WEEKDAYS: OptionPair[] = [
  { label: "Monday", key: "1", value: RRule.MO },
  { label: "Tuesday", key: "2", value: RRule.TU },
  { label: "Wednesday", key: "3", value: RRule.WE },
  { label: "Thursday", key: "4", value: RRule.TH },
  { label: "Friday", key: "5", value: RRule.FR },
  { label: "Saturday", key: "6", value: RRule.SA },
  { label: "Sunday", key: "7", value: RRule.SU },
];

export const MONTHDAYS: OptionPair[] = [
  { label: "1", key: "1", value: "1" },
  { label: "2", key: "2", value: "2" },
  { label: "3", key: "3", value: "3" },
  { label: "4", key: "4", value: "4" },
  { label: "5", key: "5", value: "5" },
  { label: "6", key: "6", value: "6" },
  { label: "7", key: "7", value: "7" },
  { label: "8", key: "8", value: "8" },
  { label: "9", key: "9", value: "9" },
  { label: "10", key: "10", value: "10" },
  { label: "11", key: "11", value: "11" },
  { label: "12", key: "12", value: "12" },
  { label: "13", key: "13", value: "13" },
  { label: "14", key: "14", value: "14" },
  { label: "15", key: "15", value: "15" },
  { label: "16", key: "16", value: "16" },
  { label: "17", key: "17", value: "17" },
  { label: "18", key: "18", value: "18" },
  { label: "19", key: "19", value: "19" },
  { label: "20", key: "20", value: "20" },
  { label: "21", key: "21", value: "21" },
  { label: "22", key: "22", value: "22" },
  { label: "23", key: "23", value: "23" },
  { label: "24", key: "24", value: "24" },
  { label: "25", key: "25", value: "25" },
  { label: "26", key: "26", value: "26" },
  { label: "27", key: "27", value: "27" },
  { label: "28", key: "28", value: "28" },
  { label: "29", key: "29", value: "29" },
  { label: "30", key: "30", value: "30" },
  { label: "31", key: "31", value: "31" },
];

const FREQ_MAP: Record<string, Frequency> = {
  daily: RRule.DAILY,
  weekly: RRule.WEEKLY,
  monthly: RRule.MONTHLY,
  yearly: RRule.YEARLY,
};

export function getRRuleFrequency(value: string): number {
  return FREQ_MAP[value.toLowerCase()] ?? RRule.WEEKLY;
}
